"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GestureSwipeHorizontalLeft2: ['gesture-swipe-horizontal-left-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.61,10.278a10.9,10.9,0,0,0-5.844-3.121,1,1,0,0,0-.443,1.95,9.011,9.011,0,0,1,4.827,2.538,1,1,0,0,0,1.46-1.367Z', 'M7.712,7.913a1,1,0,0,0-1.2-.754,17.263,17.263,0,0,0-3.7,1.262.251.251,0,0,1-.313-.08l-.519-.729a.75.75,0,0,0-1.35.307L.132,10.855a.749.749,0,0,0,.616.867l2.941.489a.751.751,0,0,0,.735-1.174l-.441-.62a.252.252,0,0,1-.038-.211.256.256,0,0,1,.14-.163,15.807,15.807,0,0,1,2.873-.934A1,1,0,0,0,7.712,7.913Z', 'M16.55,12.413,12.809,11.3a.25.25,0,0,1-.179-.239V6.489a1,1,0,1,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.856-1.449-2.762.224l2.913,4.368a.5.5,0,0,0,.416.222h5.434a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.776-4.165A1.281,1.281,0,0,0,16.55,12.413Z']],
  GestureSwipeVerticalDown: ['gesture-swipe-vertical-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.44,7.057a1,1,0,0,0,1.95-.443A12.344,12.344,0,0,0,14.333.4a1,1,0,0,0-1.366,1.461A10.585,10.585,0,0,1,15.44,7.057Z', 'M16.636,16.424a1,1,0,0,0-1.2.754,15.31,15.31,0,0,1-.9,2.767.251.251,0,0,1-.374.1l-.578-.413a.751.751,0,0,0-1.176.734l.479,2.87a.75.75,0,0,0,.739.626c.082,0-.167.038,2.994-.489a.75.75,0,0,0,.312-1.35l-.7-.5a.249.249,0,0,1-.079-.312,16.838,16.838,0,0,0,1.228-3.6A1,1,0,0,0,16.636,16.424Z', 'M16.5,8.632H4.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h12a3.5,3.5,0,0,0,0-7Zm0,5H15.375A.375.375,0,0,1,15,13.257v-2.25a.375.375,0,0,1,.375-.375H16.5a1.5,1.5,0,0,1,0,3Z']],
  GestureSwipeVerticalDown1: ['gesture-swipe-vertical-down-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.245,22.015A1.746,1.746,0,0,1,13.368,21l-.424-1.272a.253.253,0,0,0-.2-.168.735.735,0,0,0-.6.169.751.751,0,0,0-.22.8l.945,2.834a.756.756,0,0,0,.949.474l2.834-.945a.747.747,0,0,0,.51-.658.736.736,0,0,0-.091-.412.249.249,0,0,0-.3-.116l-1.192.4A1.754,1.754,0,0,1,14.245,22.015Z', 'M15.385,6.465a1,1,0,0,0,1.951-.442A10.5,10.5,0,0,0,14.313.381a1,1,0,0,0-1.366,1.461A8.492,8.492,0,0,1,15.385,6.465Z', 'M15.243,17.022a.249.249,0,0,1-.353.158l-.471-.235a.751.751,0,0,0-1.047.908l.944,2.834a.752.752,0,0,0,.949.474l2.834-.945a.751.751,0,0,0,.1-1.382l-1.027-.513a.25.25,0,0,1-.129-.291c.073-.257.139-.522.2-.789.028-.116.061-.225.088-.343a.99.99,0,0,0-1.9-.561.85.85,0,0,0-.054.119C15.341,16.65,15.293,16.837,15.243,17.022Z', 'M19,11.382a3.5,3.5,0,0,0-3.5-3.5H5.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h10A3.5,3.5,0,0,0,19,11.382Zm-5,1.125v-2.25a.375.375,0,0,1,.375-.375H15.5a1.5,1.5,0,0,1,0,3H14.375A.375.375,0,0,1,14,12.507Z']],
  GestureSwipeVerticalUp1: ['gesture-swipe-vertical-up-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.028,1.8a1.753,1.753,0,0,1,.553.09l1.192.4a.251.251,0,0,0,.3-.116A.746.746,0,0,0,16.652,1.1L13.817.152a.747.747,0,0,0-.949.474L11.923,3.46a.751.751,0,0,0,.712.987.583.583,0,0,0,.155-.024.22.22,0,0,0,.148-.141l.43-1.29A1.75,1.75,0,0,1,15.028,1.8Z', 'M16.583,16.776a1,1,0,0,0-1.2.754,8.509,8.509,0,0,1-2.438,4.624,1,1,0,0,0,1.367,1.46,10.517,10.517,0,0,0,3.022-5.642A1,1,0,0,0,16.583,16.776Z', 'M18.2,5.161a.751.751,0,0,0-.1-1.382l-2.834-.945a.748.748,0,0,0-.949.474l-.944,2.834a.751.751,0,0,0,1.047.909l.465-.233a.251.251,0,0,1,.353.156c.052.183.1.368.147.565a1,1,0,0,0,.051.121.987.987,0,0,0,1.146.633,1,1,0,0,0,.754-1.2c-.027-.119-.063-.223-.091-.34-.066-.268-.135-.531-.208-.787a.25.25,0,0,1,.129-.292Z', 'M19,12.613a3.5,3.5,0,0,0-3.5-3.5H5.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h10A3.5,3.5,0,0,0,19,12.613Zm-3.5,1.5H14.375A.375.375,0,0,1,14,13.738v-2.25a.375.375,0,0,1,.375-.375H15.5a1.5,1.5,0,0,1,0,3Z']],
  GestureSwipeVerticalDownTwoFingers: ['gesture-swipe-vertical-down-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.1,23.373a.751.751,0,0,0,.212-1.411l-.97-.485a.249.249,0,0,1-.118-.321,24.015,24.015,0,0,0,1.753-9.283A20.159,20.159,0,0,0,17.934.565a1,1,0,1,0-1.658,1.118,18.192,18.192,0,0,1,2.7,10.19,22.088,22.088,0,0,1-1.531,8.357.246.246,0,0,1-.143.138.249.249,0,0,1-.2-.01l-.7-.352a.751.751,0,0,0-1.032.949l.978,2.446a.753.753,0,0,0,.819.461Z', 'M16.061,15.372a3,3,0,0,0-3-3H3.449a.429.429,0,0,0-.429.428v5.143a.429.429,0,0,0,.429.428h9.612A3,3,0,0,0,16.061,15.372Zm-3,1.5h-1a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h1a1.5,1.5,0,0,1,0,3Z', 'M3.02,10.944a.429.429,0,0,0,.429.428H13.02a3,3,0,1,0,0-6H3.449A.429.429,0,0,0,3.02,5.8Zm8.5-3.572a.5.5,0,0,1,.5-.5h1a1.5,1.5,0,0,1,0,3h-1a.5.5,0,0,1-.5-.5Z']],
  GestureSwipeVerticalUp: ['gesture-swipe-vertical-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.588,4.362l.576-.411a.248.248,0,0,1,.211-.038.251.251,0,0,1,.163.14,15.154,15.154,0,0,1,.9,2.767,1,1,0,0,0,1.95-.443,16.63,16.63,0,0,0-1.234-3.592.251.251,0,0,1,.079-.313l.7-.5a.75.75,0,0,0-.313-1.35L13.754.143a.751.751,0,0,0-.863.616l-.479,2.869A.751.751,0,0,0,13.588,4.362Z', 'M16.636,16.187a1,1,0,0,0-1.2.754,10.586,10.586,0,0,1-2.473,5.194A1,1,0,0,0,14.333,23.6a12.344,12.344,0,0,0,3.057-6.213A1,1,0,0,0,16.636,16.187Z', 'M16.5,8.365H4.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h12a3.5,3.5,0,0,0,0-7Zm0,5H15.375A.375.375,0,0,1,15,12.99V10.74a.375.375,0,0,1,.375-.375H16.5a1.5,1.5,0,0,1,0,3Z']],
  GestureSwipeHorizontalLeft1: ['gesture-swipe-horizontal-left-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.887,8.418l.4-1.195a.251.251,0,0,0-.115-.3.715.715,0,0,0-.415-.089.749.749,0,0,0-.658.511L.153,10.182a.75.75,0,0,0,.475.948l2.834.945a.753.753,0,0,0,.8-.22.738.738,0,0,0,.168-.6.246.246,0,0,0-.168-.2l-1.272-.425A1.75,1.75,0,0,1,1.887,8.418Z', 'M23.616,9.686a10.515,10.515,0,0,0-5.641-3.023,1,1,0,1,0-.444,1.95,8.5,8.5,0,0,1,4.624,2.439,1,1,0,1,0,1.461-1.366Z', 'M8.3,7.418a1,1,0,0,0-1.2-.754c-.119.027-.225.062-.341.091-.268.065-.532.133-.789.206a.251.251,0,0,1-.291-.129L5.163,5.8a.727.727,0,0,0-.725-.413A.753.753,0,0,0,3.78,5.9L2.836,8.734a.751.751,0,0,0,.474.949l2.834.944A.751.751,0,0,0,7.053,9.58l-.234-.466a.251.251,0,0,1,.156-.353c.184-.052.37-.1.567-.147a1.052,1.052,0,0,0,.119-.053A.989.989,0,0,0,8.3,7.418Z', 'M12.615,5a3.5,3.5,0,0,0-3.5,3.5v10a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5V8.5A3.5,3.5,0,0,0,12.615,5Zm1.5,4.625A.375.375,0,0,1,13.74,10H11.49a.375.375,0,0,1-.375-.375V8.5a1.5,1.5,0,1,1,3,0Z']],
  GestureDoubleTap: ['gesture-double-tap', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,4.866a6.6,6.6,0,0,0-5.59,10.087.75.75,0,1,0,1.271-.795A5.09,5.09,0,1,1,16.45,9a5.023,5.023,0,0,1-.139,5.172.75.75,0,1,0,1.269.8A6.6,6.6,0,0,0,12,4.866Z', 'M21.9,7.323A10.692,10.692,0,0,0,12,.866a10.685,10.685,0,0,0-9.9,6.47A10.715,10.715,0,0,0,4.013,19.042a.751.751,0,0,0,1.106-1.015A9.231,9.231,0,0,1,3.47,7.939,9.2,9.2,0,0,1,12,2.366a9.21,9.21,0,0,1,8.527,5.562A9.23,9.23,0,0,1,18.906,18a.749.749,0,1,0,1.107,1.01A10.706,10.706,0,0,0,21.9,7.323Z', 'M16.416,17.036,12.674,15.92a.25.25,0,0,1-.178-.24V11.112a1,1,0,0,0-2,0v7.064a.25.25,0,0,1-.455.143c-1.49-2.139-3.856-1.45-2.762.223l2.912,4.367a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.775-4.165A1.282,1.282,0,0,0,16.416,17.036Z']],
  GestureFlipLeft: ['gesture-flip-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.515,6.951a1,1,0,0,0,1.259-.643,4.928,4.928,0,0,1,1-1.88.25.25,0,0,1,.428.121l.067.334a.75.75,0,0,0,1.358.271l1.5-2.237a.751.751,0,0,0-.206-1.041L10.68.376a.75.75,0,0,0-1.152.769l.139.7a.248.248,0,0,1-.13.27A5.724,5.724,0,0,0,6.871,5.691,1,1,0,0,0,7.515,6.951Z', 'M16.25,8.249a3,3,0,0,0-3,3v4.072a.428.428,0,0,0,.429.428h5.142a.428.428,0,0,0,.429-.428V11.249A3,3,0,0,0,16.25,8.249Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M7.75,8.249a3,3,0,0,0-3,3v4.072a.428.428,0,0,0,.429.428h5.142a.428.428,0,0,0,.429-.428V11.249A3,3,0,0,0,7.75,8.249Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M16.484,17.048a1,1,0,0,0-1.259.643,4.894,4.894,0,0,1-1,1.873.249.249,0,0,1-.428-.121l-.065-.327a.751.751,0,0,0-1.359-.271l-1.5,2.237a.752.752,0,0,0,.206,1.041l2.245,1.5a.751.751,0,0,0,1.152-.771l-.142-.709a.252.252,0,0,1,.128-.27,5.771,5.771,0,0,0,2.669-3.566A1,1,0,0,0,16.484,17.048Z']],
  GestureSwipeHorizontal2: ['gesture-swipe-horizontal-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.428,12.525l-3.741-1.117a.25.25,0,0,1-.179-.239V6.6a1,1,0,1,0-2,0v7.064a.25.25,0,0,1-.455.142c-1.49-2.138-3.855-1.449-2.761.224L10.2,18.4a.5.5,0,0,0,.416.223h5.434a.5.5,0,0,0,.493-.411c.2-1.1.664-3.683.775-4.165A1.282,1.282,0,0,0,16.428,12.525Z', 'M23.835,9.1a.752.752,0,0,0,0-.938l-2-2.5A.747.747,0,0,0,21,5.421a.688.688,0,0,0-.233.136.25.25,0,0,0-.03.344l1.432,1.79a1.5,1.5,0,0,1,0,1.874l-1.432,1.79a.251.251,0,0,0,.03.345.722.722,0,0,0,.233.136.749.749,0,0,0,.833-.239Z', 'M1.829,9.565a1.5,1.5,0,0,1,0-1.874L3.261,5.9a.25.25,0,0,0-.03-.344A.688.688,0,0,0,3,5.421a.747.747,0,0,0-.833.238l-2,2.5a.752.752,0,0,0,0,.938l2,2.5a.75.75,0,0,0,.585.281.735.735,0,0,0,.481-.178.25.25,0,0,0,.031-.344Z', 'M5.75,6.128a.75.75,0,0,0-1.335-.469l-2,2.5a.752.752,0,0,0,0,.938l2,2.5a.75.75,0,0,0,1.335-.469Z', 'M21.585,9.1a.752.752,0,0,0,0-.938l-2-2.5a.751.751,0,0,0-1.335.469v5a.75.75,0,0,0,1.335.469Z']],
  GestureSwipeHorizontal1: ['gesture-swipe-horizontal-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.835,7.654l-2-2.5A.751.751,0,0,0,21,4.915a.722.722,0,0,0-.233.136.25.25,0,0,0-.03.345l1.432,1.79a1.5,1.5,0,0,1,0,1.874l-1.432,1.79a.251.251,0,0,0,.03.345.722.722,0,0,0,.233.136.749.749,0,0,0,.833-.239l2-2.5A.752.752,0,0,0,23.835,7.654Z', 'M1.829,7.186,3.261,5.4a.251.251,0,0,0-.03-.345A.722.722,0,0,0,3,4.915a.75.75,0,0,0-.833.239l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.749.749,0,0,0,3,11.331a.722.722,0,0,0,.233-.136.25.25,0,0,0,.03-.345L1.829,9.06A1.5,1.5,0,0,1,1.829,7.186Z', 'M4.415,5.154l-2,2.5a.752.752,0,0,0,0,.938l2,2.5a.75.75,0,0,0,1.335-.469v-5A.75.75,0,0,0,4.415,5.154Z', 'M19.585,5.154a.751.751,0,0,0-1.335.469v5a.75.75,0,0,0,1.335.469l2-2.5a.752.752,0,0,0,0-.938Z', 'M12,5.125a3.5,3.5,0,0,0-3.5,3.5v10a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-10A3.5,3.5,0,0,0,12,5.125ZM13.5,9.75a.374.374,0,0,1-.375.375h-2.25A.375.375,0,0,1,10.5,9.75V8.625a1.5,1.5,0,0,1,3,0Z']],
  GestureSwipeHorizontal11: ['gesture-swipe-horizontal-1_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.419,12.527l-3.741-1.115a.251.251,0,0,1-.179-.24V6.6a1,1,0,0,0-2,0v7.065a.25.25,0,0,1-.455.143c-1.49-2.138-3.856-1.45-2.762.221l2.912,4.37a.5.5,0,0,0,.416.222h5.435a.5.5,0,0,0,.492-.41c.2-1.1.662-3.675.775-4.166A1.282,1.282,0,0,0,16.419,12.527Z', 'M6.25,7.624H3.75a.25.25,0,0,1-.25-.25V6.124a.751.751,0,0,0-1.336-.468l-2,2.5a.75.75,0,0,0,0,.937l2,2.5A.751.751,0,0,0,3.5,11.124V9.874a.25.25,0,0,1,.25-.25h2.5a1,1,0,0,0,0-2Z', 'M23.836,9.093a.75.75,0,0,0,0-.937l-2-2.5a.751.751,0,0,0-1.336.468v1.25a.25.25,0,0,1-.25.25h-2.5a1,1,0,0,0,0,2h2.5a.25.25,0,0,1,.25.25v1.25a.751.751,0,0,0,1.336.469Z']],
  GestureSwipeHorizontalLeft: ['gesture-swipe-horizontal-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.6,9.742a12.341,12.341,0,0,0-6.213-3.058,1,1,0,0,0-.442,1.951,10.59,10.59,0,0,1,5.2,2.473A1,1,0,1,0,23.6,9.742Z', 'M6.378,6.685a16.918,16.918,0,0,0-3.6,1.225.25.25,0,0,1-.312-.08l-.494-.691a.75.75,0,0,0-1.35.313L.144,10.321a.75.75,0,0,0,.616.863l2.87.478a.751.751,0,0,0,.733-1.176L3.95,9.907a.249.249,0,0,1,.1-.374,15.234,15.234,0,0,1,2.767-.9,1,1,0,0,0-.442-1.951Z', 'M11.739,4a3.5,3.5,0,0,0-3.5,3.5v12a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5V7.5A3.5,3.5,0,0,0,11.739,4Zm1.5,4.625A.375.375,0,0,1,12.864,9h-2.25a.374.374,0,0,1-.375-.375V7.5a1.5,1.5,0,1,1,3,0Z']],
  GestureScroll: ['gesture-scroll', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.033,2.163A.751.751,0,0,0,9.5,3.5h1.25a.25.25,0,0,1,.25.25v1.5a1,1,0,1,0,2,0v-1.5a.25.25,0,0,1,.25-.25H14.5a.751.751,0,0,0,.469-1.336l-2.5-2a.752.752,0,0,0-.938,0Z', 'M14.5,20.5h-1.25a.25.25,0,0,1-.25-.25v-1.5a1,1,0,0,0-2,0v1.5a.25.25,0,0,1-.25.25H9.5a.751.751,0,0,0-.469,1.335l2.5,2a.751.751,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14.5,20.5Z', 'M11.5,15.574V10.961a3,3,0,0,0-6,0v4.613A.429.429,0,0,0,5.929,16h5.142A.429.429,0,0,0,11.5,15.574ZM10,11.962a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.5,8a3,3,0,0,0-3,3v4.572a.429.429,0,0,0,.429.428h5.142a.429.429,0,0,0,.429-.428V11A3,3,0,0,0,15.5,8ZM17,12a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,14,12V11a1.5,1.5,0,0,1,3,0Z']],
  GestureSwipeHorizontal: ['gesture-swipe-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.75,8h-2a.249.249,0,0,1-.25-.25V6.5A.75.75,0,0,0,2.165,6.03l-2,2.5a.748.748,0,0,0,0,.937l2,2.5A.75.75,0,0,0,3.5,11.5v-1.25A.25.25,0,0,1,3.75,10h2a1,1,0,1,0,0-2Z', 'M23.835,8.53l-2-2.5A.75.75,0,0,0,20.5,6.5v1.25a.249.249,0,0,1-.25.25h-2a1,1,0,1,0,0,2h2a.25.25,0,0,1,.25.25V11.5a.75.75,0,0,0,1.335.469l2-2.5A.748.748,0,0,0,23.835,8.53Z', 'M12.125,5a3.5,3.5,0,0,0-3.5,3.5v10a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5V8.5A3.5,3.5,0,0,0,12.125,5Zm1.5,4.625A.375.375,0,0,1,13.25,10H11a.375.375,0,0,1-.375-.375V8.5a1.5,1.5,0,0,1,3,0Z']],
  GestureSwipeHorizontalLeftTwoFingers: ['gesture-swipe-horizontal-left-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.7,7.454a1,1,0,0,0-.27-1.389A20.146,20.146,0,0,0,12.125,3.019,24.021,24.021,0,0,0,2.843,4.772a.249.249,0,0,1-.322-.118l-.485-.97A.751.751,0,0,0,.625,3.9L.136,6.83A.75.75,0,0,0,.6,7.65l2.445.978A.75.75,0,0,0,3.992,7.6l-.352-.7a.252.252,0,0,1,.128-.343,22.115,22.115,0,0,1,8.357-1.53,18.171,18.171,0,0,1,10.19,2.705A1,1,0,0,0,23.7,7.454Z', 'M8.626,7.938a3,3,0,0,0-3,3v9.613a.429.429,0,0,0,.429.428H11.2a.429.429,0,0,0,.429-.428V10.938A3,3,0,0,0,8.626,7.938Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.626,7.979a3,3,0,0,0-3,3v9.573a.429.429,0,0,0,.429.428H18.2a.429.429,0,0,0,.429-.428V10.978A3,3,0,0,0,15.626,7.979Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z']],
  GestureSwipeHorizontalRight: ['gesture-swipe-horizontal-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.378,7.452a.75.75,0,0,0-1.35-.313l-.5.695a.249.249,0,0,1-.312.08,16.867,16.867,0,0,0-3.6-1.229,1,1,0,1,0-.443,1.951,15.13,15.13,0,0,1,2.767.9.251.251,0,0,1,.1.374l-.413.577a.751.751,0,0,0,.734,1.176l2.869-.478a.75.75,0,0,0,.617-.863Z', 'M6.616,6.684A12.341,12.341,0,0,0,.4,9.742a1,1,0,0,0,1.461,1.366A10.577,10.577,0,0,1,7.058,8.635a1,1,0,0,0-.442-1.951Z', 'M12.261,4a3.5,3.5,0,0,0-3.5,3.5v12a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5V7.5A3.5,3.5,0,0,0,12.261,4Zm1.5,4.625A.375.375,0,0,1,13.386,9h-2.25a.375.375,0,0,1-.375-.375V7.5a1.5,1.5,0,1,1,3,0Z']],
  GestureSwipeHorizontalRight2: ['gesture-swipe-horizontal-right-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.352,7.92A.751.751,0,0,0,22,7.612l-.525.734a.249.249,0,0,1-.312.079,17.118,17.118,0,0,0-3.685-1.264,1,1,0,1,0-.443,1.95,15.638,15.638,0,0,1,2.86.931.249.249,0,0,1,.1.374l-.442.618a.751.751,0,0,0,.733,1.176l2.951-.489a.75.75,0,0,0,.617-.868Z', 'M7.436,7.912a1,1,0,0,0-1.2-.753A10.882,10.882,0,0,0,.4,10.277a1,1,0,0,0,1.46,1.367A9,9,0,0,1,6.682,9.109,1,1,0,0,0,7.436,7.912Z', 'M16.3,12.413,12.559,11.3a.25.25,0,0,1-.179-.239V6.489a1,1,0,1,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.855-1.449-2.761.224l2.912,4.368a.5.5,0,0,0,.416.222h5.434a.5.5,0,0,0,.492-.411c.2-1.1.665-3.683.776-4.165A1.281,1.281,0,0,0,16.3,12.413Z']],
  GestureSwipeVertical11: ['gesture-swipe-vertical-1_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.51,10.5H10.446a.25.25,0,0,1-.143-.455c2.139-1.49,1.45-3.856-.222-2.762L5.712,10.2a.5.5,0,0,0-.222.416v5.435a.5.5,0,0,0,.411.492c1.1.2,3.678.663,4.165.775a1.282,1.282,0,0,0,1.52-.893L12.7,12.678a.25.25,0,0,1,.24-.178H17.51a1,1,0,0,0,0-2Z', 'M10.492,3.5h1.25a.25.25,0,0,1,.25.25v2a1,1,0,0,0,2,0v-2a.25.25,0,0,1,.25-.25h1.25a.75.75,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2A.75.75,0,0,0,10.492,3.5Z', 'M15.492,20.5h-1.25a.25.25,0,0,1-.25-.25v-2a1,1,0,0,0-2,0v2a.25.25,0,0,1-.25.25h-1.25a.75.75,0,0,0-.469,1.335l2.5,2a.752.752,0,0,0,.938,0l2.5-2A.75.75,0,0,0,15.492,20.5Z']],
  GestureSwipeHorizontalRightTwoFingers: ['gesture-swipe-horizontal-right-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.389,3.9a.75.75,0,0,0-1.411-.215l-.487.973a.249.249,0,0,1-.322.117,23.933,23.933,0,0,0-9.282-1.755A20.178,20.178,0,0,0,.565,6.065,1,1,0,1,0,1.684,7.724a18.2,18.2,0,0,1,10.2-2.7,22,22,0,0,1,8.356,1.536.25.25,0,0,1,.127.343l-.349.7a.751.751,0,0,0,.951,1.031l2.433-.979a.749.749,0,0,0,.461-.816Z', 'M8.375,7.938a3,3,0,0,0-3,3v9.613a.428.428,0,0,0,.428.428h5.142a.429.429,0,0,0,.429-.428V10.938A3,3,0,0,0,8.375,7.938Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.375,7.979a3,3,0,0,0-3,3v9.573a.428.428,0,0,0,.428.428h5.142a.429.429,0,0,0,.429-.428V10.978A3,3,0,0,0,15.375,7.979Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z']],
  GestureSwipeVertical: ['gesture-swipe-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,20.5h-1.25a.25.25,0,0,1-.25-.25v-2a1,1,0,0,0-2,0v2a.25.25,0,0,1-.25.25H12.5a.75.75,0,0,0-.469,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,17.5,20.5Z', 'M12.5,3.5h1.25a.25.25,0,0,1,.25.25v2a1,1,0,0,0,2,0v-2a.25.25,0,0,1,.25-.25H17.5a.75.75,0,0,0,.468-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,12.5,3.5Z', 'M19,11.875a3.5,3.5,0,0,0-3.5-3.5H5.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h10A3.5,3.5,0,0,0,19,11.875ZM14,13V10.75a.374.374,0,0,1,.375-.375H15.5a1.5,1.5,0,1,1,0,3H14.376A.374.374,0,0,1,14,13Z']],
  GestureSwipeVertical1: ['gesture-swipe-vertical-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,1.5a1.5,1.5,0,0,1,.937.329L13.73,3.26a.25.25,0,0,0,.344-.03A.7.7,0,0,0,14.21,3a.747.747,0,0,0-.239-.833l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.749.749,0,0,0,7.8,3a.7.7,0,0,0,.136.232.249.249,0,0,0,.344.031l1.79-1.432A1.5,1.5,0,0,1,11,1.5Z', 'M11,22.5a1.5,1.5,0,0,1-.937-.328l-1.79-1.432a.25.25,0,0,0-.344.03A.71.71,0,0,0,7.8,21a.75.75,0,0,0,.239.834l2.5,2a.751.751,0,0,0,.937,0l2.5-2A.749.749,0,0,0,14.21,21a.71.71,0,0,0-.136-.232.25.25,0,0,0-.344-.031L11.939,22.17A1.5,1.5,0,0,1,11,22.5Z', 'M13.5,18.248h-5a.75.75,0,0,0-.469,1.336l2.5,2a.751.751,0,0,0,.937,0l2.5-2a.75.75,0,0,0-.468-1.336Z', 'M8.5,5.749h5a.75.75,0,0,0,.468-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,8.5,5.749Z', 'M14,12a3.5,3.5,0,0,0-3.5-3.5H.5A.5.5,0,0,0,0,9v6a.5.5,0,0,0,.5.5h10A3.5,3.5,0,0,0,14,12ZM9,13.123v-2.25a.375.375,0,0,1,.375-.375H10.5a1.5,1.5,0,0,1,0,3H9.375A.374.374,0,0,1,9,13.123Z']],
  GestureTap2: ['gesture-tap-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,2.614A7.25,7.25,0,0,0,5.852,13.707a.75.75,0,1,0,1.271-.795,5.751,5.751,0,1,1,9.745.011.75.75,0,0,0,1.27.8A7.25,7.25,0,0,0,12,2.614Z', 'M16.417,15.288l-3.742-1.117a.249.249,0,0,1-.178-.239V9.364a1,1,0,0,0-2,0v7.064a.25.25,0,0,1-.456.142c-1.489-2.138-3.855-1.449-2.761.224l2.912,4.367a.5.5,0,0,0,.416.223h5.436a.5.5,0,0,0,.492-.409c.218-1.185.774-4.167.774-4.167A1.281,1.281,0,0,0,16.417,15.288Z']],
  GestureSwipeVerticalUpTwoFingers: ['gesture-swipe-vertical-up-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.224,2.841a.25.25,0,0,1,.118-.322l.974-.487A.75.75,0,0,0,20.1.622L17.169.132a.753.753,0,0,0-.82.461l-.978,2.446a.75.75,0,0,0,1.031.949l.7-.348a.246.246,0,0,1,.2-.01.251.251,0,0,1,.144.138,22.306,22.306,0,0,1,1.538,8.353,18.182,18.182,0,0,1-2.7,10.19,1,1,0,1,0,1.658,1.118A20.146,20.146,0,0,0,20.98,12.121,23.879,23.879,0,0,0,19.224,2.841Z', 'M13.061,5.623H3.448a.428.428,0,0,0-.428.428v5.142a.429.429,0,0,0,.428.429h9.613a3,3,0,1,0,0-6Zm0,4.5h-1a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h1a1.5,1.5,0,0,1,0,3Z', 'M13.02,12.623H3.448a.428.428,0,0,0-.428.428v5.142a.429.429,0,0,0,.428.429H13.02a3,3,0,1,0,0-6Zm0,4.5h-1a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h1a1.5,1.5,0,0,1,0,3Z']],
  GestureTap: ['gesture-tap', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,5.874a4.255,4.255,0,0,0-4.25,4.25v11.5a.75.75,0,0,0,.75.75h7a.75.75,0,0,0,.75-.75v-11.5A4.255,4.255,0,0,0,12,5.874Zm2,6a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1.5a2,2,0,0,1,4,0Z', 'M12,1.624a8.556,8.556,0,0,0-7.255,13.09.75.75,0,1,0,1.271-.8,7.055,7.055,0,1,1,11.958.016.75.75,0,0,0,1.269.8A8.557,8.557,0,0,0,12,1.624Z']],
  GestureTap1: ['gesture-tap-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,7.5a4.255,4.255,0,0,0-4.25,4.25v11.5A.75.75,0,0,0,8.5,24h7a.75.75,0,0,0,.75-.75v-11.5A4.255,4.255,0,0,0,12,7.5Zm2,6a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V12a2,2,0,0,1,4,0Z', 'M20.555,12.048a8.555,8.555,0,1,0-15.81,4.536.75.75,0,0,0,1.271-.8,7.055,7.055,0,1,1,11.958.015.75.75,0,0,0,1.269.8A8.524,8.524,0,0,0,20.555,12.048Z', 'M20.485,3.508A12,12,0,0,0,3.515,20.479a.75.75,0,0,0,1.06-1.061,10.5,10.5,0,1,1,14.85,0,.75.75,0,0,0,1.06,1.061A12.014,12.014,0,0,0,20.485,3.508Z']],
  GestureTapSwipeLeft: ['gesture-tap-swipe-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,9.373a1,1,0,0,0-1-1H3.75a.249.249,0,0,1-.25-.25V6.873a.751.751,0,0,0-1.336-.468l-2,2.5a.75.75,0,0,0,0,.937l2,2.5A.751.751,0,0,0,3.5,11.873v-1.25a.25.25,0,0,1,.25-.25H8.5A1,1,0,0,0,9.5,9.373Z', 'M16.75,3.623a7.251,7.251,0,0,0-6.138,11.11.75.75,0,1,0,1.269-.8,5.751,5.751,0,1,1,9.745-.013.75.75,0,0,0,1.273.8A7.252,7.252,0,0,0,16.75,3.623Z', 'M16.745,7.374a3.5,3.5,0,0,0-3.5,3.5v9a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-9A3.5,3.5,0,0,0,16.745,7.374ZM18.245,12a.375.375,0,0,1-.375.375H15.62A.375.375,0,0,1,15.245,12V10.874a1.5,1.5,0,1,1,3,0Z']],
  GestureTapAllDirection1: ['gesture-tap-all-direction-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,1.5a1.5,1.5,0,0,1,.937.329l1.791,1.432a.25.25,0,0,0,.344-.03A.722.722,0,0,0,15.208,3a.749.749,0,0,0-.239-.833l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.747.747,0,0,0,8.793,3a.715.715,0,0,0,.135.232.25.25,0,0,0,.345.031l1.79-1.432A1.5,1.5,0,0,1,12,1.5Z', 'M12,22.5a1.5,1.5,0,0,1-.937-.329l-1.79-1.432a.25.25,0,0,0-.345.031A.7.7,0,0,0,8.793,21a.747.747,0,0,0,.239.833l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.749.749,0,0,0,15.208,21a.722.722,0,0,0-.136-.233.249.249,0,0,0-.344-.03l-1.791,1.432A1.5,1.5,0,0,1,12,22.5Z', 'M23.835,11.031l-2-2.5A.752.752,0,0,0,21,8.292a.728.728,0,0,0-.232.136.251.251,0,0,0-.031.345l1.433,1.79a1.5,1.5,0,0,1,0,1.874l-1.433,1.79a.251.251,0,0,0,.031.345.707.707,0,0,0,.232.135.749.749,0,0,0,.834-.238l2-2.5A.752.752,0,0,0,23.835,11.031Z', 'M1.829,10.563l1.432-1.79a.25.25,0,0,0-.03-.345A.728.728,0,0,0,3,8.292a.751.751,0,0,0-.834.239l-2,2.5a.752.752,0,0,0,0,.938l2,2.5a.75.75,0,0,0,.585.281.739.739,0,0,0,.481-.178.25.25,0,0,0,.031-.344L1.829,12.437A1.5,1.5,0,0,1,1.829,10.563Z', 'M9.5,5.75h5a.75.75,0,0,0,.469-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,9.5,5.75Z', 'M14.5,18.25h-5a.75.75,0,0,0-.468,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,14.5,18.25Z', 'M4.415,8.531l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.751.751,0,0,0,5.75,14V9A.75.75,0,0,0,4.415,8.531Z', 'M19.585,8.531A.751.751,0,0,0,18.25,9v5a.75.75,0,0,0,1.335.469l2-2.5a.752.752,0,0,0,0-.938Z', 'M12,8.5A3.5,3.5,0,0,0,8.5,12v3.5A.5.5,0,0,0,9,16h6a.5.5,0,0,0,.5-.5V12A3.5,3.5,0,0,0,12,8.5Zm1.5,4.625a.375.375,0,0,1-.375.375h-2.25a.375.375,0,0,1-.375-.375V12a1.5,1.5,0,0,1,3,0Z']],
  GestureTapClock1: ['gesture-tap-clock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.665,17.536,9.924,16.419a.25.25,0,0,1-.178-.24V11.612a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.456.143c-1.49-2.138-3.855-1.449-2.761.223l2.912,4.368a.5.5,0,0,0,.416.222h5.434a.5.5,0,0,0,.493-.41c.2-1.1.664-3.684.775-4.166A1.281,1.281,0,0,0,13.665,17.536Z', 'M4.118,6.99a7.293,7.293,0,0,0-.99,9.021A.75.75,0,1,0,4.392,15.2,5.744,5.744,0,0,1,11.059,6.67a.246.246,0,0,0,.245-.051.25.25,0,0,0,.078-.239,5.973,5.973,0,0,1-.131-1.044.25.25,0,0,0-.188-.233A7.254,7.254,0,0,0,4.118,6.99Z', 'M14.1,15.2a.75.75,0,1,0,1.264.807,7.2,7.2,0,0,0,1.05-4.776.252.252,0,0,0-.2-.216,5.99,5.99,0,0,1-1-.263.25.25,0,0,0-.33.282A5.746,5.746,0,0,1,14.1,15.2Z', 'M17.245.367A4.75,4.75,0,1,0,22,5.117,4.755,4.755,0,0,0,17.245.367Zm0,8a3.25,3.25,0,1,1,3.25-3.25A3.254,3.254,0,0,1,17.245,8.367Z', 'M19.013,4.367h-.768a.25.25,0,0,1-.25-.25V3.349a.75.75,0,0,0-1.5,0V5.117a.75.75,0,0,0,.75.75h1.768a.75.75,0,0,0,0-1.5Z']],
  GestureTapSwipeDown: ['gesture-tap-swipe-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.126,20.5h-1.25a.25.25,0,0,1-.25-.25V15.5a1,1,0,0,0-2,0v4.75a.25.25,0,0,1-.25.25h-1.25a.75.75,0,0,0-.469,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,17.126,20.5Z', 'M13.126,0A7.246,7.246,0,0,0,9.283,1.1a.75.75,0,1,0,.8,1.272,5.751,5.751,0,1,1-.012,9.745.75.75,0,1,0-.8,1.27A7.25,7.25,0,1,0,13.126,0Z', 'M16.624,7.254a3.5,3.5,0,0,0-3.5-3.5h-9a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h9A3.5,3.5,0,0,0,16.624,7.254Zm-5,1.125V6.129A.375.375,0,0,1,12,5.754h1.125a1.5,1.5,0,0,1,0,3H12A.375.375,0,0,1,11.624,8.379Z']],
  GestureTapSwipeDown1: ['gesture-tap-swipe-down-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.32,20.5H16.07a.25.25,0,0,1-.25-.25V15a1,1,0,0,0-2,0V20.25a.249.249,0,0,1-.25.25H12.32a.75.75,0,0,0-.468,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,17.32,20.5Z', 'M17.7.858a6.652,6.652,0,0,0-6.847.186.75.75,0,0,0,.8,1.27A5.246,5.246,0,0,1,19.68,6.75a5.246,5.246,0,0,1-8.018,4.443.75.75,0,0,0-.795,1.271A6.69,6.69,0,0,0,14.425,13.5a6.759,6.759,0,0,0,3.282-.862A6.65,6.65,0,0,0,21.18,6.75,6.644,6.644,0,0,0,17.7.858Z', 'M15.84,6.509a1,1,0,0,0-1-1H7.776a.25.25,0,0,1-.142-.455C9.772,3.565,9.083,1.2,7.41,2.293L3.043,5.205a.5.5,0,0,0-.223.415v5.434a.5.5,0,0,0,.411.492c1.1.2,3.683.664,4.165.775a1.282,1.282,0,0,0,1.52-.893l1.117-3.741a.249.249,0,0,1,.239-.178H14.84A1,1,0,0,0,15.84,6.509Z']],
  GestureTapSwipeVertical: ['gesture-tap-swipe-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.125,20.5h-5a.75.75,0,0,0-.468,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,17.125,20.5Z', 'M12.125,3.5h5a.75.75,0,0,0,.469-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,12.125,3.5Z', 'M13.125,4.75A7.231,7.231,0,0,0,9.266,5.862a.75.75,0,1,0,.8,1.269,5.751,5.751,0,1,1,.013,9.745.75.75,0,0,0-.795,1.273,7.25,7.25,0,1,0,3.842-13.4Z', 'M16.625,12a3.5,3.5,0,0,0-3.5-3.5h-9a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h9A3.5,3.5,0,0,0,16.625,12Zm-5,1.125V10.87A.374.374,0,0,1,12,10.5h1.125a1.5,1.5,0,1,1,0,3H12A.374.374,0,0,1,11.625,13.12Z']],
  GestureTapTwoFingers: ['gesture-tap-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.25,9.124a3,3,0,0,0-3,3V19.7a.428.428,0,0,0,.428.428h5.143a.428.428,0,0,0,.428-.428V12.123A3,3,0,0,0,8.25,9.124Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.75,6.624a3,3,0,0,0-3,3V19.7a.428.428,0,0,0,.428.428h5.143a.428.428,0,0,0,.428-.428V9.623A3,3,0,0,0,15.75,6.624Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.75,3.874a5.727,5.727,0,0,0-3.159.945.75.75,0,0,0,.825,1.253,4.252,4.252,0,0,1,6.528,4.243.75.75,0,0,0,1.481.241A5.756,5.756,0,0,0,15.75,3.874Z', 'M8.25,7.874a4.255,4.255,0,0,1,1.007.12.75.75,0,1,0,.352-1.458,5.752,5.752,0,0,0-6.927,7.025.75.75,0,1,0,1.452-.374A4.254,4.254,0,0,1,8.25,7.874Z']],
  GestureTapTwoFingersClock: ['gesture-tap-two-fingers-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,13a3,3,0,0,0-3,3v7.573A.429.429,0,0,0,4.429,24H9.571A.429.429,0,0,0,10,23.571V16A3,3,0,0,0,7,13Zm1.5,4a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5V16a1.5,1.5,0,0,1,3,0Z', 'M14.5,10.5a3,3,0,0,0-3,3V23.571a.429.429,0,0,0,.429.428h5.142a.429.429,0,0,0,.429-.428V13.5A3,3,0,0,0,14.5,10.5Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M18,10.749a.138.138,0,0,0-.11.219,4.186,4.186,0,0,1,.86,2.531,4.245,4.245,0,0,1-.056.69.75.75,0,1,0,1.48.243,5.708,5.708,0,0,0-.642-3.7.25.25,0,0,0-.272-.123A5.876,5.876,0,0,1,18,10.749Z', 'M13.045,8.12a.25.25,0,0,0-.281-.1,5.682,5.682,0,0,0-1.423.672.75.75,0,1,0,.824,1.253,4.146,4.146,0,0,1,1.422-.591.249.249,0,0,0,.127-.419A6.035,6.035,0,0,1,13.045,8.12Z', 'M7,11.749a4.247,4.247,0,0,1,1.006.12.75.75,0,1,0,.353-1.458,5.755,5.755,0,0,0-6.928,7.025.75.75,0,1,0,1.453-.373A4.255,4.255,0,0,1,7,11.749Z', 'M18,0a4.75,4.75,0,1,0,4.75,4.75A4.756,4.756,0,0,0,18,0Zm0,8a3.25,3.25,0,1,1,3.25-3.25A3.254,3.254,0,0,1,18,8Z', 'M19.768,4H19a.25.25,0,0,1-.25-.25V2.981a.75.75,0,0,0-1.5,0V4.749A.75.75,0,0,0,18,5.5h1.768a.75.75,0,1,0,0-1.5Z']],
  GestureTwoFingerFlipLeft: ['gesture-two-finger-flip-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.039,12.069a.25.25,0,0,1-.14-.293l1.247-4.657a.93.93,0,0,0-1.8-.454l-1.43,4.592a.25.25,0,0,1-.3.168l-.584-.143a.25.25,0,0,1-.19-.243V6.482a1,1,0,0,0-2,0v7.062a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.223l2.912,4.367a.5.5,0,0,0,.416.223h5.434a.5.5,0,0,0,.492-.411c.2-1.1.665-3.683.776-4.165C16.907,12.83,15.993,12.5,15.039,12.069Z', 'M8.038,19.471a.75.75,0,0,0-1.348-.094l-.233.408a.249.249,0,0,1-.415.029A9.533,9.533,0,0,1,4.61,16.951a1,1,0,1,0-1.9.617,10.452,10.452,0,0,0,2.4,4.211.25.25,0,0,1,.041.3l-.455.8a.751.751,0,0,0,.889,1.083l3-1a.75.75,0,0,0,.459-.989Z', 'M21.28,5.908a10,10,0,0,0-2.219-3.681.25.25,0,0,1-.041-.3l.458-.8a.751.751,0,0,0-.89-1.083l-2.985,1a.751.751,0,0,0-.459.986l.985,2.5a.75.75,0,0,0,1.349.1l.236-.414a.251.251,0,0,1,.416-.028A9.18,9.18,0,0,1,19.4,6.6a1,1,0,0,0,1.878-.687Z']],
  GestureTwoFingerTapClock: ['gesture-two-finger-tap-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.2,17.44a.249.249,0,0,1-.139-.293l1.247-4.657a.93.93,0,0,0-1.8-.454l-1.43,4.591a.25.25,0,0,1-.3.169l-.585-.143A.251.251,0,0,1,7,16.41V11.852a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.856-1.449-2.762.224L4.7,23.649a.5.5,0,0,0,.416.222h5.435a.5.5,0,0,0,.492-.41c.2-1.1.664-3.684.775-4.166C12.069,18.2,11.155,17.866,10.2,17.44Z', 'M2.5,12.121a.75.75,0,0,0,.75-.75A2.631,2.631,0,0,1,4.457,9.1,2.836,2.836,0,0,1,7.1,8.839.75.75,0,0,0,7.7,7.462a4.353,4.353,0,0,0-4.065.384,4.143,4.143,0,0,0-1.88,3.525A.75.75,0,0,0,2.5,12.121Z', 'M10.5,8.121a.75.75,0,0,0,0,1.5,2.755,2.755,0,0,1,1.969,4.67.75.75,0,1,0,1.074,1.047A4.254,4.254,0,0,0,10.5,8.121Z', 'M17.744.126a4.75,4.75,0,1,0,4.75,4.75A4.756,4.756,0,0,0,17.744.126Zm0,8a3.25,3.25,0,1,1,3.25-3.25A3.254,3.254,0,0,1,17.744,8.126Z', 'M19.511,4.126h-.767a.25.25,0,0,1-.25-.25V3.109a.75.75,0,0,0-1.5,0V4.876a.75.75,0,0,0,.75.75h1.767a.75.75,0,0,0,0-1.5Z']],
  GestureTwoFingersSwipeDown: ['gesture-two-fingers-swipe-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.533,9.345H7.47a.25.25,0,0,1-.143-.456C9.465,7.4,8.776,5.034,7.1,6.128L2.736,9.04a.5.5,0,0,0-.223.416v5.435a.5.5,0,0,0,.411.492c1.1.2,3.683.664,4.166.776,1.093.252,1.429-.662,1.855-1.616a.249.249,0,0,1,.292-.14L13.9,15.649a.929.929,0,0,0,.454-1.8L9.757,12.418a.249.249,0,0,1-.168-.3l.143-.585a.25.25,0,0,1,.243-.19h4.558A1,1,0,0,0,14.533,9.345Z', 'M20.61,23.373a.751.751,0,0,0,.212-1.411l-.968-.484a.249.249,0,0,1-.118-.321,24.013,24.013,0,0,0,1.751-9.284A20.153,20.153,0,0,0,18.44.565a1,1,0,1,0-1.658,1.118,18.178,18.178,0,0,1,2.7,10.19,22.07,22.07,0,0,1-1.531,8.357.255.255,0,0,1-.144.139.251.251,0,0,1-.2-.011l-.7-.352a.751.751,0,0,0-1.032.95l.979,2.445a.752.752,0,0,0,.82.461Z']],
  GestureTwoFingersSwipeLeft: ['gesture-two-fingers-swipe-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.829,14.294a.251.251,0,0,1-.14-.293l1.247-4.658a.93.93,0,0,0-1.8-.454L12.7,13.481a.249.249,0,0,1-.3.168l-.585-.143a.25.25,0,0,1-.19-.243V8.705a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.224L9.326,20.5a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.411c.2-1.1.664-3.684.775-4.166C16.7,15.055,15.783,14.719,14.829,14.294Z', 'M23.7,7.708a1,1,0,0,0-.27-1.388A20.147,20.147,0,0,0,12.125,3.273,24.021,24.021,0,0,0,2.843,5.027a.251.251,0,0,1-.322-.118l-.485-.971A.751.751,0,0,0,.625,4.15L.136,7.085A.749.749,0,0,0,.6,7.9l2.445.978A.75.75,0,0,0,3.992,7.85l-.352-.7A.252.252,0,0,1,3.768,6.8a22.1,22.1,0,0,1,8.357-1.531,18.171,18.171,0,0,1,10.19,2.705A1,1,0,0,0,23.7,7.708Z']],
  GestureTwoFingersSwipeRight: ['gesture-two-fingers-swipe-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.583,14.294a.249.249,0,0,1-.14-.293L15.69,9.343a.93.93,0,0,0-1.8-.454l-1.43,4.592a.249.249,0,0,1-.3.168l-.585-.143a.25.25,0,0,1-.19-.243V8.705a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.856-1.449-2.762.224L9.08,20.5a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.411c.2-1.1.664-3.684.775-4.166C16.451,15.055,15.537,14.719,14.583,14.294Z', 'M23.389,4.153a.751.751,0,0,0-1.411-.215l-.486.972a.25.25,0,0,1-.322.117,23.949,23.949,0,0,0-9.283-1.754A20.178,20.178,0,0,0,.565,6.32,1,1,0,1,0,1.684,7.978a18.2,18.2,0,0,1,10.2-2.7,22.012,22.012,0,0,1,8.357,1.535.254.254,0,0,1,.138.144.251.251,0,0,1-.011.2l-.35.7a.751.751,0,0,0,.951,1.031L23.405,7.9a.75.75,0,0,0,.461-.816Z']],
  GestureTwoFingersHorizontalZoomIn: ['gesture-two-fingers-horizontal-zoom-in', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.7,12.073a.251.251,0,0,1-.14-.293L15.8,7.123A.929.929,0,0,0,14,6.669l-1.43,4.592a.251.251,0,0,1-.3.168l-.584-.143a.25.25,0,0,1-.19-.243V6.485a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.224L9.2,18.282a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.412c.2-1.1.664-3.683.775-4.165C16.566,12.835,15.652,12.5,14.7,12.073Z', 'M2.414,7.542l-2,2.5a.752.752,0,0,0,0,.938l2,2.5a.751.751,0,0,0,1.336-.469v-5A.751.751,0,0,0,2.414,7.542Z', 'M23.586,10.042l-2-2.5a.751.751,0,0,0-1.336.469v5a.751.751,0,0,0,1.336.469l2-2.5A.752.752,0,0,0,23.586,10.042Z']],
  GestureTwoFingersScroll: ['gesture-two-fingers-scroll', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.524,12.059a.249.249,0,0,1-.137-.3l1.239-4.132a.93.93,0,0,0-1.8-.454L13.4,11.254a.25.25,0,0,1-.295.161l-.593-.144a.25.25,0,0,1-.191-.243V6.99a1,1,0,0,0-2,0v6.544a.25.25,0,0,1-.455.143c-1.49-2.139-3.856-1.45-2.762.221l2.911,3.434a.5.5,0,0,0,.383.177l5.085-.018a.5.5,0,0,0,.465-.319c.333-.861,1.074-2.766,1.187-3.258C17.386,12.823,16.477,12.485,15.524,12.059Z', 'M11.314,3.749h5a.751.751,0,0,0,.468-1.336l-2.5-2a.75.75,0,0,0-.937,0l-2.5,2A.751.751,0,0,0,11.314,3.749Z', 'M16.314,20.249h-5a.75.75,0,0,0-.469,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,16.314,20.249Z']],
  GestureZoomInTwoFingers: ['gesture-zoom-in-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.165,9.3l-2,2.5a.749.749,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.5,14.766v-5A.75.75,0,0,0,2.165,9.3Z', 'M23.835,11.8l-2-2.5a.75.75,0,0,0-1.335.469v5a.75.75,0,0,0,1.335.469l2-2.5A.749.749,0,0,0,23.835,11.8Z', 'M8.5,7.979a3,3,0,0,0-3,3v4.613a.428.428,0,0,0,.428.428h5.143a.428.428,0,0,0,.428-.428V10.978A3,3,0,0,0,8.5,7.979Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.5,8.019a3,3,0,0,0-3,3v4.572a.428.428,0,0,0,.428.428h5.143a.428.428,0,0,0,.428-.428V11.019A3,3,0,0,0,15.5,8.019Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,1,1,3,0Z']],
  GestureExpand1: ['gesture-expand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,3.5h1.25a.25.25,0,0,1,.25.25v1.5a1,1,0,0,0,2,0V3.75a.25.25,0,0,1,.25-.25H14a.75.75,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2A.75.75,0,0,0,9,3.5Z', 'M14,20.5H12.75a.25.25,0,0,1-.25-.25v-1.5a1,1,0,0,0-2,0v1.5a.25.25,0,0,1-.25.25H9a.75.75,0,0,0-.469,1.335l2.5,2a.752.752,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14,20.5Z', 'M5.25,10.5H3.75a.25.25,0,0,1-.25-.25V9a.751.751,0,0,0-1.336-.469l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.5,14V12.75a.25.25,0,0,1,.25-.25h1.5a1,1,0,0,0,0-2Z', 'M23.836,11.031l-2-2.5A.751.751,0,0,0,20.5,9v1.25a.25.25,0,0,1-.25.25h-1.5a1,1,0,0,0,0,2h1.5a.25.25,0,0,1,.25.25V14a.751.751,0,0,0,1.336.469l2-2.5A.752.752,0,0,0,23.836,11.031Z', 'M12.662,10.542a.251.251,0,0,1-.162-.234V8.48a1,1,0,1,0-2,0v3.367a.25.25,0,0,1-.409.193c-1.076-.886-2.658-.192-1.591,1.44l1.694,2.78a.5.5,0,0,0,.427.24H15.23a.5.5,0,0,0,.484-.375c.218-.839.644-2.483.753-2.955C16.78,11.81,15.46,11.594,12.662,10.542Z']],
  GestureSwipeHorizontalRight3: ['gesture-swipe-horizontal-right-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.311,12.581,12.57,11.464a.25.25,0,0,1-.178-.24V6.657a1,1,0,0,0-2,0V13.72a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.224l2.912,4.367a.5.5,0,0,0,.416.222h5.435a.5.5,0,0,0,.492-.41c.2-1.1.664-3.684.775-4.166A1.281,1.281,0,0,0,16.311,12.581Z', 'M23.847,10.116,22.9,7.282a.749.749,0,0,0-.658-.51.722.722,0,0,0-.414.09.249.249,0,0,0-.115.3l.4,1.194a1.75,1.75,0,0,1-1.107,2.213l-1.271.424a.248.248,0,0,0-.168.2.738.738,0,0,0,.168.6.75.75,0,0,0,.8.22l2.834-.945A.75.75,0,0,0,23.847,10.116Z', 'M8.879,7.124a1,1,0,0,0-1.134-.845C4.49,6.755,2.014,7.879.384,9.621a1,1,0,0,0,1.461,1.366A10.289,10.289,0,0,1,8.034,8.258,1,1,0,0,0,8.879,7.124Z', 'M17.021,8.692a.252.252,0,0,1,.165.139.249.249,0,0,1,0,.215l-.234.469a.75.75,0,0,0,.908,1.047l2.834-.945a.75.75,0,0,0,.474-.948L20.22,5.835a.75.75,0,0,0-1.383-.1l-.515,1.032a.25.25,0,0,1-.293.128c-.256-.074-.516-.144-.785-.209-.7-.172-1.436-.321-2.2-.433a1,1,0,0,0-.291,1.979c.542.079,1.063.182,1.57.293C16.561,8.579,16.794,8.634,17.021,8.692Z']],
  GestureSwipeHorizontalRight1: ['gesture-swipe-horizontal-right-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.848,10.182,22.9,7.348a.749.749,0,0,0-.659-.511.742.742,0,0,0-.411.093.249.249,0,0,0-.116.3l.4,1.19a1.749,1.749,0,0,1-1.107,2.213l-1.272.424a.251.251,0,0,0-.168.2.738.738,0,0,0,.169.6.754.754,0,0,0,.8.22l2.834-.945a.75.75,0,0,0,.475-.948Z', 'M6.025,6.663A10.515,10.515,0,0,0,.384,9.686a1,1,0,1,0,1.461,1.366A8.5,8.5,0,0,1,6.469,8.613a1,1,0,1,0-.444-1.95Z', 'M17.025,8.759a.25.25,0,0,1,.157.353l-.234.468a.751.751,0,0,0,.908,1.047l2.834-.944a.751.751,0,0,0,.475-.949L20.22,5.9a.752.752,0,0,0-1.383-.1l-.513,1.026a.25.25,0,0,1-.291.13c-.257-.072-.523-.139-.79-.2-.116-.029-.222-.063-.341-.09a.99.99,0,0,0-.562,1.9.85.85,0,0,0,.119.054C16.655,8.658,16.841,8.708,17.025,8.759Z', 'M11.385,5a3.5,3.5,0,0,0-3.5,3.5v10a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5V8.5A3.5,3.5,0,0,0,11.385,5Zm1.5,4.625A.374.374,0,0,1,12.51,10H10.26a.375.375,0,0,1-.375-.375V8.5a1.5,1.5,0,1,1,3,0Z']],
  GestureTapSwipeRight: ['gesture-tap-swipe-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.836,8.9l-2-2.5a.751.751,0,0,0-1.336.468v1.25a.249.249,0,0,1-.25.25H15.5a1,1,0,0,0,0,2h4.75a.25.25,0,0,1,.25.25v1.25a.751.751,0,0,0,1.336.469l2-2.5A.75.75,0,0,0,23.836,8.9Z', 'M7.25,3.623A7.252,7.252,0,0,0,1.1,14.716a.75.75,0,1,0,1.272-.795,5.75,5.75,0,1,1,9.746.013.749.749,0,1,0,1.268.8A7.25,7.25,0,0,0,7.25,3.623Z', 'M7.254,7.374a3.5,3.5,0,0,0-3.5,3.5v9a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-9A3.5,3.5,0,0,0,7.254,7.374ZM8.754,12a.375.375,0,0,1-.375.375H6.129A.375.375,0,0,1,5.754,12V10.874a1.5,1.5,0,0,1,3,0Z']],
  GestureTapSwipeHorizontal: ['gesture-tap-swipe-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.164,6.405l-2,2.5a.75.75,0,0,0,0,.937l2,2.5A.751.751,0,0,0,3.5,11.873v-5A.751.751,0,0,0,2.164,6.405Z', 'M23.836,8.9l-2-2.5a.751.751,0,0,0-1.336.468v5a.751.751,0,0,0,1.336.469l2-2.5A.75.75,0,0,0,23.836,8.9Z', 'M12,3.623A7.25,7.25,0,0,0,5.852,14.716a.75.75,0,1,0,1.271-.795,5.75,5.75,0,1,1,9.745.013.75.75,0,0,0,1.27.8A7.251,7.251,0,0,0,12,3.623Z', 'M12,7.374a3.5,3.5,0,0,0-3.5,3.5v9a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-9A3.5,3.5,0,0,0,12,7.374ZM13.5,12a.374.374,0,0,1-.375.375h-2.25A.375.375,0,0,1,10.5,12V10.874a1.5,1.5,0,0,1,3,0Z']],
  GestureTapAllDirection: ['gesture-tap-all-direction', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,3.5h5a.75.75,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2A.75.75,0,0,0,9.5,3.5Z', 'M14.5,20.5h-5a.75.75,0,0,0-.469,1.335l2.5,2a.752.752,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14.5,20.5Z', 'M2.164,8.531l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.5,14V9A.751.751,0,0,0,2.164,8.531Z', 'M23.836,11.031l-2-2.5A.751.751,0,0,0,20.5,9v5a.751.751,0,0,0,1.336.469l2-2.5A.752.752,0,0,0,23.836,11.031Z', 'M12,5.75A7.25,7.25,0,0,0,5.852,16.842a.749.749,0,1,0,1.271-.794,5.751,5.751,0,1,1,9.745.012.75.75,0,0,0,1.27.8A7.251,7.251,0,0,0,12,5.75Z', 'M12,9.5A3.5,3.5,0,0,0,8.5,13v3.5A.5.5,0,0,0,9,17h6a.5.5,0,0,0,.5-.5V13A3.5,3.5,0,0,0,12,9.5Zm1.5,4.625a.375.375,0,0,1-.375.375h-2.25a.375.375,0,0,1-.375-.375V13a1.5,1.5,0,0,1,3,0Z']],
  GestureTapClock: ['gesture-tap-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.9,7.5a4.255,4.255,0,0,0-4.25,4.25v11.5A.75.75,0,0,0,6.4,24h7a.75.75,0,0,0,.75-.75v-11.5A4.255,4.255,0,0,0,9.9,7.5Zm-2,6V12a2,2,0,1,1,4,0v1.5a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,7.9,13.5Z', 'M11.989,3.756a.25.25,0,0,0-.191-.284,8.371,8.371,0,0,0-1.9-.223,8.556,8.556,0,0,0-7.255,13.09.75.75,0,1,0,1.271-.8A7.051,7.051,0,0,1,11.626,4.966a.226.226,0,0,0,.193-.04.223.223,0,0,0,.087-.177A6.021,6.021,0,0,1,11.989,3.756Z', 'M17.18,10.7a.249.249,0,0,0-.28.279,6.6,6.6,0,0,1,.054.824,7.037,7.037,0,0,1-1.081,3.755.749.749,0,0,0,.235,1.034.739.739,0,0,0,.4.116.75.75,0,0,0,.635-.35A8.527,8.527,0,0,0,18.454,11.8a8.011,8.011,0,0,0-.047-.839.249.249,0,0,0-.263-.223c-.079,0-.158.007-.238.007A5.8,5.8,0,0,1,17.18,10.7Z', 'M17.906,0a4.75,4.75,0,1,0,4.75,4.75A4.756,4.756,0,0,0,17.906,0Zm0,8a3.25,3.25,0,1,1,3.25-3.25A3.254,3.254,0,0,1,17.906,8Z', 'M19.674,4h-.768a.25.25,0,0,1-.25-.25V2.981a.75.75,0,0,0-1.5,0V4.749a.75.75,0,0,0,.75.75h1.768a.75.75,0,1,0,0-1.5Z']],
  GestureTapHorizontalExpand: ['gesture-tap-horizontal-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.164,6.21l-2,2.5a.75.75,0,0,0,0,.937l2,2.5A.75.75,0,0,0,3.5,11.679v-5A.751.751,0,0,0,2.164,6.21Z', 'M23.836,8.71l-2-2.5a.75.75,0,0,0-1.335.469v5a.75.75,0,0,0,1.335.468l2-2.5A.75.75,0,0,0,23.836,8.71Z', 'M17.894,6.3a6.727,6.727,0,0,0-11.78-.008,6.656,6.656,0,0,0,.173,6.84.75.75,0,1,0,1.271-.795,5.237,5.237,0,1,1,9.023-5.313,5.171,5.171,0,0,1-.143,5.324.75.75,0,0,0,1.27.8A6.653,6.653,0,0,0,17.894,6.3Z', 'M16.422,15.083l-3.741-1.117a.25.25,0,0,1-.179-.239V9.159a1,1,0,1,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.855-1.449-2.762.224L10.2,20.956a.5.5,0,0,0,.416.223h5.434a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.775-4.166A1.281,1.281,0,0,0,16.422,15.083Z']],
  GestureTapSwipeRight1: ['gesture-tap-swipe-right-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.836,8.71l-2-2.5a.751.751,0,0,0-1.336.469v1.25a.25.25,0,0,1-.25.25H15a1,1,0,0,0,0,2h5.25a.25.25,0,0,1,.25.25v1.25a.751.751,0,0,0,1.336.468l2-2.5A.75.75,0,0,0,23.836,8.71Z', 'M12.644,6.3A6.649,6.649,0,0,0,6.75,2.819,6.745,6.745,0,0,0,1.035,13.132a.75.75,0,1,0,1.271-.795A5.246,5.246,0,0,1,6.75,4.319a5.246,5.246,0,0,1,4.437,8.029.75.75,0,1,0,1.269.8A6.653,6.653,0,0,0,12.644,6.3Z', 'M11.171,15.083,7.429,13.966a.249.249,0,0,1-.178-.239V9.159a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.224l2.912,4.367a.5.5,0,0,0,.416.223H10.8a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.775-4.166A1.281,1.281,0,0,0,11.171,15.083Z']],
  GestureTapSwipeUp1: ['gesture-tap-swipe-up-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.32,3.5h1.25a.249.249,0,0,1,.25.25V9a1,1,0,0,0,2,0V3.749a.25.25,0,0,1,.25-.25h1.25a.75.75,0,0,0,.469-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,12.32,3.5Z', 'M17.707,11.363a6.655,6.655,0,0,0-6.841.173.75.75,0,0,0,.8,1.271,5.237,5.237,0,1,1-.01,8.88.75.75,0,1,0-.8,1.269A6.678,6.678,0,0,0,14.422,24a6.766,6.766,0,0,0,3.277-.858,6.726,6.726,0,0,0,.008-11.779Z', 'M15.84,16.751a1,1,0,0,0-1-1H7.776a.25.25,0,0,1-.142-.455c2.138-1.489,1.449-3.855-.224-2.761L3.043,15.447a.5.5,0,0,0-.223.415V21.3a.5.5,0,0,0,.411.492c1.1.2,3.683.664,4.165.775a1.282,1.282,0,0,0,1.52-.893l1.116-3.741a.251.251,0,0,1,.24-.178H14.84A1,1,0,0,0,15.84,16.751Z']],
  GestureTapVerticalExpand: ['gesture-tap-vertical-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.32,3.5h5a.751.751,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2A.75.75,0,0,0,12.32,3.5Z', 'M17.32,20.5h-5a.751.751,0,0,0-.469,1.335l2.5,2a.751.751,0,0,0,.938,0l2.5-2A.751.751,0,0,0,17.32,20.5Z', 'M17.707,6.115a6.656,6.656,0,0,0-6.84.172.75.75,0,0,0,.8,1.272,5.237,5.237,0,1,1,5.312,9.022,5.171,5.171,0,0,1-5.323-.143.75.75,0,0,0-.8,1.27,6.68,6.68,0,0,0,3.57,1.044,6.766,6.766,0,0,0,3.277-.858,6.726,6.726,0,0,0,.008-11.779Z', 'M15.84,11.5a1,1,0,0,0-1-1H7.776a.25.25,0,0,1-.142-.455c2.138-1.49,1.449-3.855-.224-2.761L3.043,10.2a.5.5,0,0,0-.223.416v5.434a.5.5,0,0,0,.411.491c1.1.2,3.683.665,4.165.776a1.283,1.283,0,0,0,1.52-.894l1.117-3.74a.25.25,0,0,1,.239-.179H14.84A1,1,0,0,0,15.84,11.5Z']],
  GestureTwoFingerZoomIn: ['gesture-two-finger-zoom-in', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.145,6.779C20.959,5.221,18.483,3.9,15.614,3.247a.25.25,0,0,1-.192-.279l.07-.487a.75.75,0,0,0-1.273-.636l-1.5,1.5a.749.749,0,0,0-.141.865l1,2a.751.751,0,0,0,1.414-.229l.075-.527a.252.252,0,0,1,.107-.172.255.255,0,0,1,.2-.036c2.315.56,4.3,1.59,5.181,2.745a1,1,0,1,0,1.591-1.212Z', 'M9.006,5.981a.751.751,0,0,0,1.414.229l1-2a.749.749,0,0,0-.141-.865l-1.5-1.5a.75.75,0,0,0-1.273.636l.069.48a.25.25,0,0,1-.193.279c-2.857.646-5.331,1.966-6.527,3.537A1,1,0,0,0,3.446,7.989a9.583,9.583,0,0,1,5.178-2.75.251.251,0,0,1,.2.037.248.248,0,0,1,.107.171Z', 'M14.7,15.943a.249.249,0,0,1-.14-.292L15.8,10.993a.93.93,0,0,0-1.8-.454l-1.43,4.592a.249.249,0,0,1-.3.168l-.584-.143a.25.25,0,0,1-.191-.243V10.355a1,1,0,0,0-2,0v7.064a.25.25,0,0,1-.455.142c-1.49-2.138-3.856-1.449-2.762.224L9.2,22.152a.5.5,0,0,0,.416.223h5.434a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.776-4.165C16.565,16.7,15.651,16.369,14.7,15.943Z']],
  GestureTwoFingersExpandAll: ['gesture-two-fingers-expand-all', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,3.749h5a.751.751,0,0,0,.469-1.336l-2.5-2a.752.752,0,0,0-.938,0l-2.5,2A.751.751,0,0,0,9.5,3.749Z', 'M14.5,20.249h-5a.75.75,0,0,0-.469,1.335l2.5,2a.75.75,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14.5,20.249Z', 'M2.414,8.529l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.75,14V9A.751.751,0,0,0,2.414,8.529Z', 'M23.586,11.967a.752.752,0,0,0,0-.938l-2-2.5A.751.751,0,0,0,20.25,9v5a.751.751,0,0,0,1.336.469Z', 'M14.573,11.525a.251.251,0,0,1-.139-.274L14.971,8.5a.93.93,0,0,0-1.8-.454l-.476,2.747a.251.251,0,0,1-.306.2l-.553-.136a.249.249,0,0,1-.19-.243V7.99a1,1,0,0,0-2,0v4.273a.25.25,0,0,1-.435.168C7.72,10.791,6.392,12.305,7.5,14l1.839,2.776A.5.5,0,0,0,9.756,17h4.95a.5.5,0,0,0,.486-.383c.211-.881.7-2.641.808-3.117C16.254,12.4,15.512,11.965,14.573,11.525Z']],
  GestureTwoFingersSwipeUp: ['gesture-two-fingers-swipe-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.034,9.592H7.97a.25.25,0,0,1-.143-.455c2.139-1.49,1.45-3.855-.223-2.762L3.237,9.288a.5.5,0,0,0-.223.416v5.435a.5.5,0,0,0,.411.492c1.1.2,3.683.664,4.165.775,1.094.252,1.43-.661,1.855-1.615a.251.251,0,0,1,.293-.14L14.4,15.9a.929.929,0,0,0,.454-1.8l-4.592-1.43a.249.249,0,0,1-.168-.3l.143-.585a.25.25,0,0,1,.243-.191h4.558A1,1,0,0,0,15.034,9.592Z', 'M19.233,2.839a.25.25,0,0,1,.118-.322l.97-.485A.75.75,0,0,0,20.11.622L17.175.132a.756.756,0,0,0-.82.461l-.978,2.446a.75.75,0,0,0,1.031.949l.7-.352a.249.249,0,0,1,.2-.01.252.252,0,0,1,.143.138,22.1,22.1,0,0,1,1.531,8.357,18.174,18.174,0,0,1-2.705,10.19,1,1,0,0,0,1.659,1.118,20.149,20.149,0,0,0,3.046-11.308A24.024,24.024,0,0,0,19.233,2.839Z']],
  GestureZoomOut: ['gesture-zoom-out', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.146,3.145,22.7,3.6a.25.25,0,0,1-.318.03A13.494,13.494,0,0,0,16.094,1.5,1,1,0,0,0,15.906,3.5,11.7,11.7,0,0,1,20.823,5.03a.249.249,0,0,1,.048.391l-.225.224A.5.5,0,0,0,21,6.5h2.5A.5.5,0,0,0,24,6V3.5A.5.5,0,0,0,23.146,3.145Z', 'M3.112,5.4a.251.251,0,0,1,.048-.391A11.75,11.75,0,0,1,8.09,3.5,1,1,0,0,0,9,2.409,1.013,1.013,0,0,0,7.91,1.5,13.277,13.277,0,0,0,1.619,3.621.25.25,0,0,1,1.3,3.592L.854,3.145A.5.5,0,0,0,0,3.5V6a.5.5,0,0,0,.5.5H3a.5.5,0,0,0,.354-.854Z', 'M6.491,9.019a3.078,3.078,0,0,0-2.06,3.3l1.052,9.734a.5.5,0,0,0,.5.446H11a.5.5,0,0,0,.5-.554l-1.12-10.386A3,3,0,0,0,6.491,9.019Zm2.064,4.249-1.988.214a.5.5,0,0,1-.551-.443l-.107-.995a1.5,1.5,0,0,1,2.983-.321L9,12.717A.5.5,0,0,1,8.555,13.268Z', 'M16.366,8.909a3.05,3.05,0,0,0-2.72,2.77L12.507,21.944a.5.5,0,0,0,.5.555h5.024a.5.5,0,0,0,.5-.445l1.091-9.835A3,3,0,0,0,16.366,8.909Zm1.76,3.15-.11.994a.5.5,0,0,1-.551.442l-1.988-.219a.5.5,0,0,1-.442-.552l.109-.994a1.5,1.5,0,0,1,2.982.329Z']],
  GestureTapSwipeLeft1: ['gesture-tap-swipe-left-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,8.179H3.749a.25.25,0,0,1-.25-.25V6.679A.75.75,0,0,0,2.164,6.21l-2,2.5a.75.75,0,0,0,0,.937l2,2.5A.75.75,0,0,0,3.5,11.679v-1.25a.25.25,0,0,1,.25-.25H9a1,1,0,0,0,0-2Z', 'M23.143,6.3a6.728,6.728,0,0,0-11.781-.008,6.66,6.66,0,0,0,.174,6.84.75.75,0,1,0,1.271-.795,5.237,5.237,0,1,1,8.879.011.75.75,0,1,0,1.269.8A6.655,6.655,0,0,0,23.143,6.3Z', 'M21.67,15.083l-3.741-1.117a.249.249,0,0,1-.178-.239V9.159a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.489-2.138-3.855-1.449-2.761.224l2.912,4.367a.5.5,0,0,0,.416.223H21.3a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.775-4.166A1.281,1.281,0,0,0,21.67,15.083Z']],
  GestureExpandTwoFingers: ['gesture-expand-two-fingers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,3.5h5a.751.751,0,0,0,.469-1.336l-2.5-2a.752.752,0,0,0-.938,0l-2.5,2A.751.751,0,0,0,9.5,3.5Z', 'M14.5,20.5h-5a.751.751,0,0,0-.469,1.335l2.5,2a.751.751,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14.5,20.5Z', 'M2.165,9.28l-2,2.5a.749.749,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.5,14.749v-5A.75.75,0,0,0,2.165,9.28Z', 'M23.835,11.78l-2-2.5a.75.75,0,0,0-1.335.469v5a.75.75,0,0,0,1.335.469l2-2.5A.749.749,0,0,0,23.835,11.78Z', 'M11.5,15.574V10.961a3,3,0,0,0-6,0v4.613A.429.429,0,0,0,5.927,16h5.142A.428.428,0,0,0,11.5,15.574ZM10,11.962a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.5,8a3,3,0,0,0-3,3v4.572a.429.429,0,0,0,.429.428h5.142a.428.428,0,0,0,.428-.428V11A3,3,0,0,0,15.5,8ZM17,12a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,14,12V11a1.5,1.5,0,0,1,3,0Z']],
  GestureTapExpandAllDirections1: ['gesture-tap-expand-all-directions-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.506,7.993a1,1,0,0,0-1,1v2.833a.25.25,0,0,1-.414.189c-1.037-.9-2.461-.335-1.586.978l2.353,2.353a.5.5,0,0,0,.354.146h2.925a.5.5,0,0,0,.477-.35c.242-.775.676-2.16.784-2.63.334-1.446-1.251-1.631-2.7-1.973a.249.249,0,0,1-.193-.243v-1.3A1,1,0,0,0,11.506,7.993Z', 'M11.063,1.829a1.5,1.5,0,0,1,1.874,0l1.791,1.432a.25.25,0,0,0,.344-.03A.722.722,0,0,0,15.208,3a.749.749,0,0,0-.239-.833l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.747.747,0,0,0,8.793,3a.715.715,0,0,0,.135.232.25.25,0,0,0,.345.031Z', 'M12.937,22.171a1.5,1.5,0,0,1-1.874,0l-1.79-1.432a.25.25,0,0,0-.345.031A.7.7,0,0,0,8.793,21a.747.747,0,0,0,.239.833l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.749.749,0,0,0,15.208,21a.722.722,0,0,0-.136-.233.249.249,0,0,0-.344-.03Z', 'M23.835,11.031l-2-2.5A.749.749,0,0,0,21,8.292a.728.728,0,0,0-.232.136.25.25,0,0,0-.03.345l1.432,1.79a1.5,1.5,0,0,1,0,1.874l-1.432,1.79a.249.249,0,0,0,.03.344.693.693,0,0,0,.232.136.749.749,0,0,0,.834-.238l2-2.5A.752.752,0,0,0,23.835,11.031Z', 'M1.829,12.437a1.5,1.5,0,0,1,0-1.874l1.432-1.79a.25.25,0,0,0-.03-.345A.728.728,0,0,0,3,8.292a.751.751,0,0,0-.834.239l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.749.749,0,0,0,3,14.707a.693.693,0,0,0,.231-.135.251.251,0,0,0,.032-.345Z', 'M9.032,4.415A.75.75,0,0,0,9.5,5.75h5a.75.75,0,0,0,.469-1.335l-2.5-2a.748.748,0,0,0-.937,0Z', 'M14.5,18.25h-5a.75.75,0,0,0-.468,1.335l2.5,2a.75.75,0,0,0,.937,0l2.5-2A.75.75,0,0,0,14.5,18.25Z', 'M5.75,9a.75.75,0,0,0-1.335-.469l-2,2.5a.752.752,0,0,0,0,.938l2,2.5A.751.751,0,0,0,5.75,14Z', 'M21.585,11.969a.752.752,0,0,0,0-.938l-2-2.5A.75.75,0,0,0,18.25,9v5a.75.75,0,0,0,1.335.469Z']],
  GestureTapSwipeUp: ['gesture-tap-swipe-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.126,3.5h1.25a.25.25,0,0,1,.25.25V8.5a1,1,0,0,0,2,0V3.749a.25.25,0,0,1,.25-.25h1.25a.75.75,0,0,0,.468-1.335l-2.5-2a.748.748,0,0,0-.937,0l-2.5,2A.75.75,0,0,0,12.126,3.5Z', 'M13.126,9.5a7.235,7.235,0,0,0-3.86,1.112.75.75,0,1,0,.8,1.269,5.75,5.75,0,1,1,.012,9.746A.75.75,0,1,0,9.283,22.9,7.25,7.25,0,1,0,13.126,9.5Z', 'M16.624,16.745a3.5,3.5,0,0,0-3.5-3.5h-9a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h9A3.5,3.5,0,0,0,16.624,16.745Zm-5,1.125V15.62A.375.375,0,0,1,12,15.245h1.125a1.5,1.5,0,0,1,0,3H12A.375.375,0,0,1,11.624,17.87Z']],
  GestureTwoFingerFlipRight: ['gesture-two-finger-flip-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.69,4.623a.75.75,0,0,0,1.348-.094l1-2.5a.753.753,0,0,0-.459-.989l-3-1A.751.751,0,0,0,4.69,1.123l.46.8a.25.25,0,0,1-.042.3,10.343,10.343,0,0,0-2.4,4.2,1,1,0,0,0,1.9.615A9.606,9.606,0,0,1,6.041,4.185a.25.25,0,0,1,.415.028Z', 'M21.28,18.092a1,1,0,1,0-1.878-.686,9.157,9.157,0,0,1-1.272,2.412.251.251,0,0,1-.416-.028l-.236-.413a.75.75,0,0,0-1.349.1l-.985,2.5a.749.749,0,0,0,.459.985l2.985,1a.751.751,0,0,0,.89-1.083l-.458-.8a.25.25,0,0,1,.041-.3A10,10,0,0,0,21.28,18.092Z', 'M14.039,12.068a.25.25,0,0,1-.14-.292l1.247-4.657a.929.929,0,0,0-1.8-.454l-1.43,4.591a.25.25,0,0,1-.3.168l-.584-.143a.249.249,0,0,1-.19-.243V6.481a1,1,0,0,0-2,0v7.062a.25.25,0,0,1-.456.143c-1.489-2.138-3.855-1.449-2.761.224l2.912,4.366a.5.5,0,0,0,.416.223h5.434a.5.5,0,0,0,.493-.411c.2-1.1.664-3.683.775-4.165C15.908,12.83,14.994,12.494,14.039,12.068Z']],
  GestureTwoFingerZoomOut: ['gesture-two-finger-zoom-out', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.749a.75.75,0,0,0-1.28-.53l-.489.489a.25.25,0,0,1-.312.033,13.705,13.705,0,0,0-6.076-1.988,1,1,0,0,0-.186,1.992,12.063,12.063,0,0,1,4.706,1.38.246.246,0,0,1,.126.184.25.25,0,0,1-.07.211l-.2.2A.75.75,0,0,0,20.75,8h2.5a.75.75,0,0,0,.75-.75Z', 'M3.58,6.519a.25.25,0,0,1,.054-.4A11.8,11.8,0,0,1,8.339,4.745a1,1,0,1,0-.178-1.992A13.433,13.433,0,0,0,2.071,4.73.25.25,0,0,1,1.759,4.7L1.28,4.219A.75.75,0,0,0,0,4.749v2.5A.75.75,0,0,0,.75,8h2.5a.75.75,0,0,0,.53-1.28Z', 'M14.7,14.818a.249.249,0,0,1-.139-.293l1.247-4.658A.93.93,0,0,0,14,9.413l-1.43,4.592a.249.249,0,0,1-.3.168l-.585-.143a.25.25,0,0,1-.19-.243V9.229a1,1,0,0,0-2,0v7.064a.25.25,0,0,1-.455.143c-1.49-2.139-3.856-1.45-2.762.223L9.2,21.026a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.411c.2-1.1.664-3.683.775-4.165C16.566,15.579,15.652,15.243,14.7,14.818Z']],
  GestureZoomIn: ['gesture-zoom-in', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.9,5.905c-1.233-1.621-3.778-2.946-6.774-3.58a.25.25,0,0,1-.2-.279l.068-.476a.5.5,0,0,0-.848-.424l-1.5,1.5a.5.5,0,0,0-.094.577l1,2a.5.5,0,0,0,.942-.153l.078-.546a.251.251,0,0,1,.3-.208c2.415.543,4.524,1.611,5.429,2.8A1,1,0,0,0,21.9,5.905Z', 'M9.853,1.146A.5.5,0,0,0,9,1.57l.066.466a.249.249,0,0,1-.2.28C5.9,2.94,3.343,4.278,2.105,5.9A1,1,0,1,0,3.7,7.113C4.619,5.9,6.7,4.84,9.123,4.307a.25.25,0,0,1,.3.209L9.5,5.07a.5.5,0,0,0,.942.153l1-2a.5.5,0,0,0-.093-.577Z', 'M5.432,9.52a3.077,3.077,0,0,0-2.06,3.3l1.052,9.734a.5.5,0,0,0,.5.447H9.945a.5.5,0,0,0,.5-.554L9.322,12.06A3,3,0,0,0,5.432,9.52ZM7.5,13.769l-1.988.214a.5.5,0,0,1-.551-.444l-.107-.994a1.5,1.5,0,0,1,2.983-.321l.107.994A.5.5,0,0,1,7.5,13.769Z', 'M17.422,9.41a3.05,3.05,0,0,0-2.72,2.77L13.564,22.444a.5.5,0,0,0,.5.556h5.024a.5.5,0,0,0,.5-.445l1.09-9.836A3,3,0,0,0,17.422,9.41Zm1.761,3.15-.11.994a.5.5,0,0,1-.552.442l-1.988-.22a.5.5,0,0,1-.442-.551l.11-.994a1.5,1.5,0,1,1,2.982.329Z']],
  GestureExpand: ['gesture-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,3.749h1.25A.25.25,0,0,1,11,4V6a1,1,0,0,0,2,0V4a.25.25,0,0,1,.25-.25H14.5a.751.751,0,0,0,.469-1.336l-2.5-2a.752.752,0,0,0-.938,0l-2.5,2A.751.751,0,0,0,9.5,3.749Z', 'M14.5,20.249H13.25A.25.25,0,0,1,13,20V18a1,1,0,0,0-2,0v2a.25.25,0,0,1-.25.25H9.5a.751.751,0,0,0-.469,1.335l2.5,2a.751.751,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14.5,20.249Z', 'M6,10.5H4a.25.25,0,0,1-.25-.25V9a.75.75,0,0,0-1.335-.469l-2,2.5a.749.749,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.75,14v-1.25A.25.25,0,0,1,4,12.5H6a1,1,0,0,0,0-2Z', 'M23.585,11.029l-2-2.5A.751.751,0,0,0,20.25,9v1.25a.25.25,0,0,1-.25.25H18a1,1,0,0,0,0,2h2a.25.25,0,0,1,.25.25V14a.75.75,0,0,0,1.335.469l2-2.5A.749.749,0,0,0,23.585,11.029Z', 'M12,8a3.5,3.5,0,0,0-3.5,3.5v4A.5.5,0,0,0,9,16h6a.5.5,0,0,0,.5-.5v-4A3.5,3.5,0,0,0,12,8Zm1.5,4.625a.375.375,0,0,1-.375.375h-2.25a.375.375,0,0,1-.375-.375V11.5a1.5,1.5,0,0,1,3,0Z']],
  GestureFlipRight: ['gesture-flip-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.369,5.154a.751.751,0,0,0,1.358-.271l.066-.328a.25.25,0,0,1,.428-.122,4.892,4.892,0,0,1,1.005,1.874,1,1,0,1,0,1.9-.615,5.777,5.777,0,0,0-2.67-3.566.25.25,0,0,1-.128-.27l.141-.71A.75.75,0,0,0,13.32.376l-2.243,1.5a.75.75,0,0,0-.206,1.041Z', 'M10.75,15.321V11.249a3,3,0,0,0-6,0v4.072a.429.429,0,0,0,.429.428h5.142A.429.429,0,0,0,10.75,15.321Zm-1.5-3.072a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M16.25,8.249a3,3,0,0,0-3,3v4.072a.429.429,0,0,0,.429.428h5.142a.429.429,0,0,0,.429-.428V11.249A3,3,0,0,0,16.25,8.249Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M11.632,18.845a.75.75,0,0,0-1.359.271l-.066.333a.25.25,0,0,1-.429.121,4.947,4.947,0,0,1-1-1.878,1,1,0,1,0-1.9.615,5.72,5.72,0,0,0,2.665,3.577.249.249,0,0,1,.129.27l-.139.7a.75.75,0,0,0,1.152.77l2.244-1.5a.752.752,0,0,0,.207-1.041Z']],
  GestureSwipeHorizontalLeft3: ['gesture-swipe-horizontal-left-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.561,12.581l-3.742-1.117a.25.25,0,0,1-.178-.239V6.657a1,1,0,0,0-2,0v7.064a.25.25,0,0,1-.455.142c-1.49-2.138-3.856-1.449-2.762.224l2.912,4.367a.5.5,0,0,0,.416.223h5.435a.5.5,0,0,0,.492-.411c.2-1.1.664-3.684.775-4.165A1.281,1.281,0,0,0,17.561,12.581Z', 'M2.994,10.566A1.749,1.749,0,0,1,1.887,8.353l.4-1.193a.252.252,0,0,0-.115-.3.732.732,0,0,0-.414-.09.748.748,0,0,0-.658.511L.153,10.117a.749.749,0,0,0,.474.948l2.834.945a.75.75,0,0,0,.8-.22.741.741,0,0,0,.169-.6.25.25,0,0,0-.168-.2Z', 'M23.569,11.035a1,1,0,0,0,.047-1.414c-1.63-1.742-4.106-2.866-7.361-3.341a1,1,0,1,0-.289,1.979,10.283,10.283,0,0,1,6.189,2.728A1,1,0,0,0,23.569,11.035Z', 'M5.971,6.9a.249.249,0,0,1-.292-.129L5.163,5.737a.75.75,0,0,0-1.383.1L2.836,8.669a.749.749,0,0,0,.474.949l2.834.944a.75.75,0,0,0,.908-1.046l-.234-.47a.248.248,0,0,1,0-.216.251.251,0,0,1,.165-.138c.227-.058.46-.113.7-.165.507-.112,1.027-.214,1.57-.294a1,1,0,0,0-.291-1.979c-.764.113-1.5.263-2.2.434C6.488,6.754,6.227,6.824,5.971,6.9Z']],
  GestureSwipeVertical2: ['gesture-swipe-vertical-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.591,12.686a.251.251,0,0,1,.24-.179H17.4a1,1,0,0,0,0-2H10.335a.25.25,0,0,1-.143-.455C12.33,8.562,11.641,6.2,9.968,7.29L5.6,10.2a.5.5,0,0,0-.222.416v5.435a.5.5,0,0,0,.41.492c1.1.2,3.684.665,4.166.776a1.281,1.281,0,0,0,1.519-.894Z', 'M16.308,22.17a1.5,1.5,0,0,1-1.874,0l-1.79-1.433a.25.25,0,0,0-.344.031.693.693,0,0,0-.136.232.75.75,0,0,0,.238.834l2.5,2a.753.753,0,0,0,.938,0l2.5-2A.752.752,0,0,0,18.579,21a.728.728,0,0,0-.136-.232.249.249,0,0,0-.344-.03Z', 'M14.434,1.828a1.5,1.5,0,0,1,1.874,0L18.1,3.26a.249.249,0,0,0,.344-.031A.717.717,0,0,0,18.579,3a.751.751,0,0,0-.239-.833l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2A.749.749,0,0,0,12.164,3a.688.688,0,0,0,.136.233.249.249,0,0,0,.344.03Z', 'M17.871,5.749a.751.751,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0l-2.5,2a.751.751,0,0,0,.469,1.335h1.25a.25.25,0,0,1,.25.25V7.5a1,1,0,0,0,2,0V6a.25.25,0,0,1,.25-.25Z', 'M12.871,18.248a.751.751,0,0,0-.469,1.336l2.5,2a.753.753,0,0,0,.938,0l2.5-2a.751.751,0,0,0-.469-1.336h-1.25a.25.25,0,0,1-.25-.25V16.5a1,1,0,1,0-2,0V18a.25.25,0,0,1-.25.25Z']],
  GestureSwipeVerticalUp3: ['gesture-swipe-vertical-up-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.343,12.64a1,1,0,0,0-1-1H10.279a.25.25,0,0,1-.142-.455c2.138-1.49,1.449-3.856-.224-2.762L5.546,11.335a.5.5,0,0,0-.223.416v5.435a.5.5,0,0,0,.411.492c1.1.2,3.683.665,4.165.776a1.283,1.283,0,0,0,1.52-.894l1.117-3.741a.25.25,0,0,1,.239-.179h4.568A1,1,0,0,0,18.343,12.64Z', 'M13.433,2.993a1.751,1.751,0,0,1,2.214-1.107l1.192.4a.25.25,0,0,0,.3-.116.747.747,0,0,0-.42-1.07L13.883.152a.747.747,0,0,0-.948.474L11.99,3.46a.749.749,0,0,0,.22.8.694.694,0,0,0,.612.167.247.247,0,0,0,.187-.166Z', 'M16.876,15.12a1,1,0,0,0-1.135.845,10.286,10.286,0,0,1-2.728,6.19,1,1,0,1,0,1.366,1.461c1.742-1.63,2.866-4.107,3.341-7.362A1,1,0,0,0,16.876,15.12Z', 'M17.108,5.968a.247.247,0,0,1,.128-.292l1.027-.514a.75.75,0,0,0-.1-1.382l-2.834-.945a.749.749,0,0,0-.949.474l-.944,2.834a.751.751,0,0,0,1.046.909l.469-.235a.25.25,0,0,1,.354.161q.088.342.167.7c.112.508.214,1.029.293,1.57a1.011,1.011,0,0,0,1.135.844,1,1,0,0,0,.844-1.135c-.112-.759-.257-1.5-.429-2.2C17.251,6.485,17.181,6.224,17.108,5.968Z']],
  GestureTapExpandAllDirection: ['gesture-tap-expand-all-direction', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.531,2.165A.75.75,0,0,0,9,3.5h5a.751.751,0,0,0,.469-1.335l-2.5-2a.749.749,0,0,0-.938,0Z', 'M14,20.5H9a.751.751,0,0,0-.469,1.335l2.5,2a.751.751,0,0,0,.938,0l2.5-2A.75.75,0,0,0,14,20.5Z', 'M2.165,8.531l-2,2.5a.749.749,0,0,0,0,.938l2,2.5A.751.751,0,0,0,3.5,14V9A.751.751,0,0,0,2.165,8.531Z', 'M23.835,11.031l-2-2.5A.75.75,0,0,0,20.5,9v5a.75.75,0,0,0,1.335.469l2-2.5A.749.749,0,0,0,23.835,11.031Z', 'M18.339,9.495a7.238,7.238,0,0,0-12.673-.01,7.156,7.156,0,0,0,.186,7.357.749.749,0,1,0,1.271-.794A5.757,5.757,0,0,1,12,7.25a5.757,5.757,0,0,1,4.869,8.809.75.75,0,0,0,1.268.8A7.15,7.15,0,0,0,18.339,9.495Z', 'M12.647,11.567a.252.252,0,0,1-.147-.229V9.5a1,1,0,1,0-2,0v3.853a.25.25,0,0,1-.414.189c-1.038-.9-2.461-.354-1.586.958l2.35,2.82a.5.5,0,0,0,.384.18h3.394a.5.5,0,0,0,.479-.355c.251-.829.749-2.475.86-2.955C16.254,12.945,15.15,12.693,12.647,11.567Z']],
  GestureTapTwoFingers1: ['gesture-tap-two-fingers-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.214,10.624a3,3,0,0,0-3,3V21.2a.428.428,0,0,0,.428.428h5.142a.429.429,0,0,0,.429-.428V13.623A3,3,0,0,0,8.214,10.624Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,0,1,3,0Z', 'M15.714,8.124a3,3,0,0,0-3,3V21.2a.428.428,0,0,0,.428.428h5.142a.429.429,0,0,0,.429-.428V11.123A3,3,0,0,0,15.714,8.124Zm1.5,4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a1.5,1.5,0,1,1,3,0Z', 'M15.714,5.374a5.729,5.729,0,0,0-3.159.945.75.75,0,0,0,.824,1.253,4.252,4.252,0,0,1,6.529,4.242.75.75,0,1,0,1.48.243,5.692,5.692,0,0,0,.076-.933A5.757,5.757,0,0,0,15.714,5.374Z', 'M23.934,8.12A8.76,8.76,0,0,0,12.681,2.914.75.75,0,1,0,13.2,4.321a7.258,7.258,0,0,1,9.323,4.314.75.75,0,1,0,1.409-.515Z', 'M8.214,9.374a4.247,4.247,0,0,1,1.006.12.75.75,0,1,0,.353-1.458,5.755,5.755,0,0,0-6.928,7.025A.75.75,0,1,0,4.1,14.688,4.255,4.255,0,0,1,8.214,9.374Z', 'M8.214,6.374a7.293,7.293,0,0,1,1.569.17.75.75,0,1,0,.323-1.464A8.759,8.759,0,0,0,.072,10.412a.75.75,0,0,0,1.4.551A7.211,7.211,0,0,1,8.214,6.374Z']],
  GestureTwoFingerTap: ['gesture-two-finger-tap', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.011,15.437a.249.249,0,0,1-.14-.293l1.247-4.657a.93.93,0,0,0-1.8-.455l-1.43,4.592a.251.251,0,0,1-.3.169L11,14.649a.249.249,0,0,1-.19-.242V9.849a1,1,0,0,0-2,0v7.063a.25.25,0,0,1-.455.143c-1.49-2.138-3.856-1.449-2.762.224l2.912,4.367a.5.5,0,0,0,.416.222h5.435a.5.5,0,0,0,.492-.41c.2-1.1.664-3.684.775-4.166C15.879,16.2,14.965,15.863,14.011,15.437Z', 'M7.443,5.843a4.143,4.143,0,0,0-1.88,3.525.75.75,0,0,0,1.5,0A2.635,2.635,0,0,1,8.267,7.1a2.832,2.832,0,0,1,2.647-.26.75.75,0,1,0,.594-1.377A4.352,4.352,0,0,0,7.443,5.843Z', 'M14.313,6.118a.75.75,0,0,0,0,1.5,2.755,2.755,0,0,1,1.969,4.67.75.75,0,1,0,1.074,1.047,4.254,4.254,0,0,0-3.043-7.217Z', 'M12.46,4.137a.75.75,0,0,0,.608-1.372,7.873,7.873,0,0,0-7.4.652A7.553,7.553,0,0,0,2.2,9.863a.75.75,0,0,0,1.5,0A6.077,6.077,0,0,1,6.483,4.674,6.355,6.355,0,0,1,12.46,4.137Z', 'M21.338,7.957a7.4,7.4,0,0,0-4.4-4.538.75.75,0,1,0-.517,1.408,5.83,5.83,0,0,1,3.5,3.628,6.588,6.588,0,0,1-.518,5.526.75.75,0,0,0,1.286.772A8.1,8.1,0,0,0,21.338,7.957Z']],
  GestureSwipeVerticalDown2: ['gesture-swipe-vertical-down-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.91,6.679a1,1,0,1,0,1.95-.442A10.88,10.88,0,0,0,13.741.4a1,1,0,0,0-1.366,1.46A8.992,8.992,0,0,1,14.91,6.679Z', 'M16.106,16.285a1,1,0,0,0-1.2.754,15.5,15.5,0,0,1-.934,2.859.251.251,0,0,1-.374.1l-.616-.44a.751.751,0,0,0-1.177.73l.478,2.951a.748.748,0,0,0,.867.619l2.946-.506a.751.751,0,0,0,.309-1.35l-.736-.525a.25.25,0,0,1-.079-.313,17.036,17.036,0,0,0,1.266-3.685A1,1,0,0,0,16.106,16.285Z', 'M18.51,11.366a1,1,0,0,0-1-1H10.446A.25.25,0,0,1,10.3,9.91c2.139-1.489,1.45-3.855-.222-2.761L5.712,10.061a.5.5,0,0,0-.222.416v5.437a.5.5,0,0,0,.411.491c4.412.8,3.586.643,4.165.776a1.286,1.286,0,0,0,1.521-.895L12.7,12.544a.25.25,0,0,1,.24-.178H17.51A1,1,0,0,0,18.51,11.366Z']],
  GestureSwipeVerticalDown3: ['gesture-swipe-vertical-down-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.343,12.256a1,1,0,0,0,0-2H10.28a.25.25,0,0,1-.143-.455c2.138-1.49,1.449-3.855-.224-2.761L5.546,9.952a.5.5,0,0,0-.223.416V15.8a.5.5,0,0,0,.411.493c1.1.2,3.684.664,4.166.775a1.281,1.281,0,0,0,1.519-.894l1.117-3.741a.25.25,0,0,1,.239-.179Z', 'M15.094,22.2A1.748,1.748,0,0,1,13.433,21l-.423-1.272a.249.249,0,0,0-.2-.168.731.731,0,0,0-.6.169.748.748,0,0,0-.221.8l.945,2.834a.755.755,0,0,0,.95.474l2.834-.944a.748.748,0,0,0,.51-.659.738.738,0,0,0-.091-.412.251.251,0,0,0-.3-.116l-1.192.4A1.722,1.722,0,0,1,15.094,22.2Z', 'M15.742,8.031a1.011,1.011,0,0,0,1.134.845,1,1,0,0,0,.844-1.134c-.475-3.255-1.6-5.731-3.34-7.361a1,1,0,0,0-1.368,1.46A10.3,10.3,0,0,1,15.742,8.031Z', 'M14.485,16.945a.751.751,0,0,0-1.048.908l.945,2.834a.75.75,0,0,0,.949.475l2.834-.945a.751.751,0,0,0,.1-1.382l-1.032-.517a.249.249,0,0,1-.129-.292c.074-.256.143-.518.209-.786.171-.7.323-1.432.435-2.2a1,1,0,0,0-1.979-.29c-.079.544-.181,1.063-.293,1.569-.052.237-.106.47-.164.7a.245.245,0,0,1-.138.166.248.248,0,0,1-.216,0Z']],
  GestureSwipeVerticalUp2: ['gesture-swipe-vertical-up-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.808,3.7a.751.751,0,0,0,1.176.729L13.593,4a.252.252,0,0,1,.374.1,15.478,15.478,0,0,1,.942,2.865,1,1,0,0,0,1.95-.443,16.915,16.915,0,0,0-1.273-3.684.25.25,0,0,1,.08-.313L16.406,2a.75.75,0,0,0-.3-1.35L13.147.132a.752.752,0,0,0-.87.622Z', 'M16.106,16.568a1,1,0,0,0-1.2.754,8.994,8.994,0,0,1-2.536,4.823,1,1,0,0,0,1.367,1.46,10.88,10.88,0,0,0,3.119-5.841A1,1,0,0,0,16.106,16.568Z', 'M18.51,11.615a1,1,0,0,0-1-1H10.446a.25.25,0,0,1-.143-.455c2.138-1.49,1.45-3.856-.222-2.762L5.712,10.31a.5.5,0,0,0-.222.416v5.437a.5.5,0,0,0,.411.491c4.412.8,3.586.643,4.165.776a1.284,1.284,0,0,0,1.52-.895L12.7,12.793a.25.25,0,0,1,.24-.178H17.51A1,1,0,0,0,18.51,11.615Z']]
};
exports["default"] = _default;